import { get } from "lodash";

const isPromise = (obj: unknown): obj is Promise<unknown> =>
  !!obj &&
  (typeof obj === "object" || typeof obj === "function") &&
  ((obj.constructor && obj.constructor.name === "Promise") ||
    typeof get(obj, "then") === "function");

export default isPromise;
